import type { UrlProvider } from './urlProvider';

export interface ResourceLocationHttp {
  type: 'http',
  provider: UrlProvider,
}

export interface ResourceLocationFile {
  type: 'file',
  filename: string,
}

export interface ResourceLocationMemory {
  type: 'memory',
  bytes: Uint8Array,
}

export type ResourceLocation = ResourceLocationHttp | ResourceLocationFile | ResourceLocationMemory;

export interface OpenResource {
  stream: ReadableStream<Uint8Array>,
  /**
   * The size of the stream. For requested ranges this will be the size of the requested range not
   * the full size of the resource.
   */
  size: number,
}


export interface ResourceAccessor {
  open(resourceLocation: ResourceLocation, start: number, end: number | null): Promise<OpenResource>;
  getSize(resourceLocation: ResourceLocation): Promise<number>;
}

export class ResourceError extends Error {
  public httpStatus: number | null = null;
  public httpStatusText: string | null = null;
  public inner: any | null = null;
  constructor(message: string, public code: 'ENOENT' | 'EIO' | 'ENOTDIR') {
    super(message);
  }
}

